import Experience from '../Experience.js'
import Environment from './Environment.js'
import Bracelet from './Bracelet.js'

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.resources.on('sourceLoaded', (source, file) =>
        {
            if(source.name === 'braceletModel' && !this.bracelet)
            {
                this.bracelet = new Bracelet()
                this.environment = new Environment()
                this.experience.needsUpdate = true
            }

            if(source.name === 'environmentMapTexture' && this.environment)
            {
                this.environment.setEnvironmentMap(file)
                this.experience.needsUpdate = true
            }
        })
    }

    update()
    {
        if(this.bracelet)
            this.bracelet.update()
    }
}
